import { AbstractControl } from '@angular/forms';

export interface IExtendedControl extends AbstractControl {
    outOfSync: boolean;
    nameOfParent: string;
    caption: string;
    controlType: ControlType;
    dataType: DataType;
    parentSchemaType: DataType;
    displayFormat: number;
    name: string;
    reportedValue: string;
    description: string;
    validationMessage: string;
    needsConfirmation: boolean;
    gradient: number;
    offset: number;
    hasGradientOrOffset: boolean;
    dropDownItems?: IDropdownItem[];
    minValue: number;
    maxValue: number;
    unit: string;
    propertyValueMetadata: PropertyValueMetadata | null;
    maxLength: number;
}

interface PropertyValueMetadata {
    changedAt?: string | null;
    error?: string | null;
    reportedAt?: string | null;
}
interface IDropdownItem {
    displayName: string;
    value: string;
}

export enum ControlType {
    TextBox = 'TextBox',
    DropDown = 'DropDown',
    Button = 'Button',
    Toggle = 'Toggle',
    Slider = 'Slider',
}

export enum DataType {
    Enum = 'Enum',
    Object = 'Object',
    String = 'string',
    Integer = 'integer',
    Long = 'long',
    Float = 'float',
    Boolean = 'boolean',
    Array = 'Array',
}
